export default {
      id: "ble_tag-usage",
      viewBox: "0 0 23 23",
      url: __webpack_public_path__ + "img/icons.svg#ble_tag",
      toString: function () {
        return this.url;
      }
    }